/**
* 设备鉴权
*/
const proximityCard = {
  
createProximityCard: "/api/createProximityCard",//创建
modifyProximityCard: "/api/modifyProximityCard",//修改
deleteProximityCard: "/api/deleteProximityCard",//删除
getProximityCards: "/api/getProximityCards",//查询
addProximityCardHoldingRecord: "/api/addProximityCardHoldingRecord",//添加
modifyProximityCardHoldingRecord: "/api/modifyProximityCardHoldingRecord",//修改
deleteProximityCardHoldingRecord: "/api/deleteProximityCardHoldingRecord",//删除
getProximityCardHoldingRecords: "/api/getProximityCardHoldingRecords",//查询
getProximityCardHoldingRecords2: "/api/getProximityCardHoldingRecords2",//查询
}

export default proximityCard